export { default as awsConfig } from './amplify';
export { default as gqlConfig } from './graphql';
export { default as kinesisConfig } from './kinesis';
